module.exports = __webpack_public_path__ + "assets/1-Chicago-Tech-Sales-Recruiters.0617cc68.png";